import WhatsNewPageItemsList from "components/pages/whats-new/whats-new-items-list-component/whats-new-items-list";
import { componentStyles } from "./whats-new-items-list-embedded-component.scss";
import { mondayConfig } from "./consts";
import { createItemsArray } from "/components/pages/whats-new/utils";

const WhatsNewItemsListEmbeddedComponent = (props) => {
  const { productFilterValue } = props;

  const items = mondayConfig?.data?.boards[0]?.items;
  const itemsArrayObj = createItemsArray(items);
  const itemsArray = itemsArrayObj?.itemsArray || [];
  const monthlyVideosSet = itemsArrayObj?.monthlyVideosSet || {};

  return (
    <div className="whats-new-items-list-embedded-component">
      <WhatsNewPageItemsList
        itemsArray={itemsArray}
        productFilterValue={productFilterValue}
        monthlyVideosSet={monthlyVideosSet}
      />

      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default WhatsNewItemsListEmbeddedComponent;
